import { base } from './';
import {
  CreateAdminResultType,
  CreateAdminType,
  IAdmin,
  SearchAdminQueryType,
  UpdateAdminType,
} from 'types';

const PATH = '/platform/admins';

const getAll = (params: SearchAdminQueryType) =>
  base.get<{
    data: IAdmin[];
    total: number;
    currentPage: number;
    totalPages: number;
  }>(PATH, { params });

const get = (id: number) => base.get<IAdmin>(`${PATH}/${id}`);

const post = (data: CreateAdminType) =>
  base.post<CreateAdminResultType>(PATH, data);

const put = (id: number, data: UpdateAdminType) =>
  base.patch(`${PATH}/${id}`, data);

const del = (id: number) => base.delete(`${PATH}/${id}`);

const putRoles = (adminId: number, roleIds: number[]) =>
  base.put(`${PATH}/${adminId}/roles`, { roleIds });

const assignRole = (adminId: number, roleId: number) =>
  base.post(`${PATH}/${adminId}/roles/${roleId}`);

const unassignRole = (adminId: number, roleId: number) =>
  base.delete(`${PATH}/${adminId}/roles/${roleId}`);

export { getAll, get, post, put, del, putRoles, assignRole, unassignRole };
